import * as React from 'react';
export const IcWifiNetwork = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.6 8.36A12.38 12.38 0 0012 4a12.27 12.27 0 00-9.6 4.37 2 2 0 00.15 2.57l8 8.44A1.998 1.998 0 0012 20a1.998 1.998 0 001.45-.62l.12-.13A4.898 4.898 0 0113 17a5 5 0 015-5c.69.005 1.372.155 2 .44l1.42-1.5a2 2 0 00.18-2.58zM20 16h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2z'
      fill='currentColor'
    />
  </svg>
);
